// extracted by mini-css-extract-plugin
export default {"padding_top_5":"UserCredentials_padding_top_5__ZOGne"};